import whenDomReady from 'when-dom-ready';
import { tns } from 'tiny-slider/src/tiny-slider';

import { getCultureFromPage } from '@utils';

class ThumbCarousel {
  constructor(carousel, controls, carouselVideo) {
    this.carousel = carousel;
    this.controls = controls;
    this.carouselVideo = carouselVideo;
    this.thumb = Array.from(this.carousel.querySelectorAll('.js-ds-video-thumb'));
    this.axis = this.carousel.getAttribute('data-slider-axis');

    this.WidthChange = () => {};

    // Shared settings.
    this.settings = {
      container: this.carousel,
      speed: 500,
      controls: true,
      nav: false,
      loop: false,
      controlsContainer: this.controls,
      axis: 'horizontal',
    };

    // Default settings: default or WidthChange query else statement.
    this.default = {
      ...this.settings,
      items: 1,
      gutter: 14,
      responsive: {
        600: {
          items: 2,
          gutter: 36,
        },
        768: {
          items: 3,
        },
        996: {
          items: 4,
        },
        1366: {
          items: 5,
        },
      },
    };

    if (this.axis === 'vertical') {
      // Media query change.
      this.WidthChange = mq => {
        if (mq.matches) {
          // Vertical slider settings.
          this.slider = tns({
            ...this.settings,
            items: 2,
            gutter: 20,
            axis: this.axis,
            responsive: {
              768: {
                items: 2,
              },
              996: {
                items: 3,
              },
              1366: {
                items: 4,
              },
            },
          });
        } else {
          // Change to default slider settings.
          this.slider = tns({
            ...this.default,
          });
        }
      };
    } else {
      // Default slider settings.
      // TODO: this needs to work properly on resize
      this.slider = tns({
        ...this.default,
      });
    }

    // Media query event handler.
    if (matchMedia) {
      const mq = window.matchMedia('(min-width: 768px)');
      mq.addListener(this.WidthChange);
      this.WidthChange(mq);
    }

    this.slider.play();

    this.thumb.forEach(item => {
      item.addEventListener('click', () => this.carouselVideo.handleClick(item));
    });

    this.carouselVideo.video.addEventListener('click', () => this.carouselVideo.handleVideo());
  }
}

class Video {
  constructor(video, langCode, subtitles) {
    this.langCode = langCode;
    this.subtitles = subtitles;
    this.video = video;
    this.iframe = this.video.querySelector('iframe');
  }

  handleClick = item => {
    // Set youtube iframe src to allow autoplay.
    this.iframe.src = `${item.getAttribute('data-youtube-src')}autoplay=1&hl=${this.langCode}&cc_lang_pref=${
      this.langCode
    }&cc_load_policy=${this.subtitles}`;

    // Add class to remove thumbnail overlay.
    if (!this.video.classList.contains('hide-thumbnail')) {
      this.video.classList.add('hide-thumbnail');
    }
  };

  handleVideo = () => {
    if (this.video.classList.contains('hide-thumbnail')) {
      return;
    }

    // Add class to remove thumbnail overlay.
    this.video.classList.add('hide-thumbnail');

    // Add autoplay to src.
    this.iframe.src = `${this.iframe.src}autoplay=1&hl=${this.langCode}&cc_lang_pref=${this.langCode}&cc_load_policy=${this.subtitles}`;
  };
}

function initialize() {
  // Get list of containers.
  const containers = Array.from(document.querySelectorAll('.js-ds-video-container'));

  if (containers.length === 0) {
    return;
  }

  const cultureCode = getCultureFromPage();
  const langCode = cultureCode.substring(0, 2);

  containers.forEach(container => {
    const subtitles = container.getAttribute('data-youtube-subtitles');

    // Get carousel in container.
    const carousel = container.querySelector('.js-ds-video-thumb-carousel');

    // Get controls in container.
    const controls = container.querySelector('.js-ds-video-controls');

    // Get video in container.
    const video = container.querySelector('.js-ds-video');

    // Create a new instance of Video class.
    const carouselVideo = new Video(video, langCode, subtitles);

    // eslint-disable-next-line no-new
    new ThumbCarousel(carousel, controls, carouselVideo);
  });
}

whenDomReady().then(initialize);
